import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

import { HomeNavigationHighlightService } from './home-navigation-highlight.service';
import { WidgetRegistrationService } from './widget-registration.service';

export const provideHome = () => [
    runOnSportsWebInit(WidgetRegistrationService),
    { provide: WidgetLayoutHook, useClass: HomeNavigationHighlightService, multi: true },
];
